import { render, staticRenderFns } from "./ImageTextList.vue?vue&type=template&id=1480910c&scoped=true&"
import script from "./ImageTextList.vue?vue&type=script&lang=js&"
export * from "./ImageTextList.vue?vue&type=script&lang=js&"
import style0 from "./ImageTextList.vue?vue&type=style&index=0&id=1480910c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1480910c",
  null
  
)

export default component.exports